import PropTypes from "prop-types";

import PrimaryButtonAnimation from "../PrimaryButton/PrimaryButtonAnimation/PrimaryButtonAnimation";
import { Loading } from "../index";

import classNames from "classnames";
import styles from "./Button.module.css";

function Button(props) {
  const {
    children,
    className,
    type,
    icon,
    loading,
    disabled,
    withAnimation,
    ...rest
  } = props;

  const iconElement = loading ? (
    <Loading className={styles["btn__loading"]} />
  ) : (
    icon
  );

  return (
    <button
      className={classNames(styles["btn"], styles[`btn--${type}`], className)}
      disabled={loading || disabled}
      {...rest}
    >
      {iconElement && (
        <span className={styles["btn__icon"]}>{iconElement}</span>
      )}
      {children}
      {withAnimation && (
        <span className={styles["btn__animation"]}>
          <PrimaryButtonAnimation />
        </span>
      )}
    </button>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(["primary", "secondary"]),
  icon: PropTypes.element,
  loading: PropTypes.bool,
};

export default Button;
